import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CloseDropdownService {

  dropdowns = {}

  constructor() { }

  public addDropdown( cityInputDependencyName ): BehaviorSubject<boolean>{
    
    if( ! this.dropdowns.hasOwnProperty( cityInputDependencyName ) ) {
      // if no input with current name exists 
      // create input 
      this.dropdowns[ cityInputDependencyName ] = new BehaviorSubject <Boolean> ( undefined );

    }
    return this.dropdowns[ cityInputDependencyName ]
  }

  public closeDropdown( cityInputDependencyName ){
    this.dropdowns[cityInputDependencyName].next( true );
  }

  public getDropdownCloseObservable( cityInputDependencyName ): BehaviorSubject<boolean>{
    return this.dropdowns[ cityInputDependencyName ]
  }

  public closeAll(): void {
    Object.values( this.dropdowns ).forEach( currentDrop => {
      
      (currentDrop as BehaviorSubject<boolean> ).next( true );
    });
  }

}
